/**
 * 客源渠道模块
 */
import React, { memo } from 'react';
import { connect } from 'react-redux';
import intl from 'react-intl-universal';

import ContentBlock, { FormItem } from '@/components/Reservation/ContentBlock';
import { createStateSelector } from '@/redux/actions/reservation/helper';
import { ReducerState, storeName } from '@/redux/reducers/reservation/checkInByReserve';

import styles from './index.module.scss';

const stateSelector = (state: ReducerState) => {
  const { channelInfo } = state;
  return { channelInfo };
};
const mapStateToProps = createStateSelector<ReducerState>(storeName, stateSelector);
const mapDispatchToProps = {};

type MapStateProps = ReturnType<typeof stateSelector>;
type MapDispatchProps = typeof mapDispatchToProps;

const Index: React.FC<MapStateProps & MapDispatchProps> = (props) => {
  const { channelInfo } = props;

  return (
    <ContentBlock
      title={intl.get('reservation_channel_block_title')}
      className={styles.channelInfo}
    >
      <FormItem label={intl.get('app_reservation_channel_name')}>
        {channelInfo.channelName}
      </FormItem>
      <FormItem label={intl.get('app_reservation_strategy_name')}>
        {channelInfo.strategyName || '—'}
      </FormItem>
      <FormItem label={intl.get('app_reservation_channel_no')}>
        {channelInfo.channelOrderNo || '—'}
      </FormItem>
    </ContentBlock>
  );
};

export default connect<MapStateProps, MapDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(memo(Index));
